<template>
  <v-dialog :value="value" persistent max-width="500px">
    <v-card color="fill">
      <v-toolbar flat dark class="main">
        <v-toolbar-title>
          TPR Alignment Export
        </v-toolbar-title>
      </v-toolbar>
      <v-card-text class="my-0 py-0">
        <v-container fluid>
          <v-row>
            <v-col>
              Select a TPR/EDLC start date and at least one ad group to generate an alignment export.
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-menu
                v-model="start_dt_picker"
                transition="scale-transition"
                offset-y
                max-width="290px"
                min-width="290px">
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="tpr_start_date"
                    label="TPR/EDLC Start Date"
                    prepend-inner-icon="mdi-calendar"
                    dense
                    type="date"
                    background-color="#fff"
                    outlined
                    hide-details
                    clearable
                    v-bind="attrs"
                    v-on="on">
                  </v-text-field>
                </template>
                <v-date-picker 
                  v-model="tpr_start_date"
                  :allowed-dates="allowedDates"
                  show-current
                  scrollable
                  no-title>
                </v-date-picker>
              </v-menu>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-autocomplete
                v-model="ad_group_ids"
                label="Ad Groups"
                :items="activeAdGroups"
                item-text="name"
                item-value="id"
                :menu-props="{ offsetY: true }"
                background-color="input"
                hide-details="auto"
                multiple
                chips
                small-chips
                outlined
                clearable
                dense>
              </v-autocomplete>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-col cols="auto">
          <v-btn 
            text
            @click="close">
            Cancel
          </v-btn>
        </v-col>
        <v-col cols="auto">
          <v-btn 
            color="primary"
            :disabled="disabled"
            :loading="generating"
            @click="generateExport">
            Generate
          </v-btn>
        </v-col>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
  // API
import Promos from '@/axios/promotion-endpoint.js'
// mixins
import { displayAlert } from '@/mixins/alert'
import { userAccess } from '@/mixins/user-access'
import { utils } from '@/mixins/utils'
export default {
  name: 'TPRAlignmentExportModal',
  data() {
    return {
      allowedDates: val => new Date(val).getDay() === 6,
      start_dt_picker: false,
      generating: false,
      tpr_start_date: null,
      ad_group_ids: []
    }
  },
  mixins: [displayAlert, userAccess, utils],
  props: {
    value: Boolean,
  },
  computed: {
    disabled() {
      return this.generating || !(this.tpr_start_date && this.ad_group_ids.length > 0)
    },
    activeAdGroups () {
      let groups = this.$store.getters.adGroups.filter((g) => {
        return g?.attributes?.AD_GROUP_IS_ACTIVE === 'True'
          && !this.totalPromoExcludedAdGroups.some(ag => ag.id === g.id)
      })
      if (this.limitAccessByRelatedStores) {
        groups = groups.filter(g => this.userRelatedPartyIds.includes(g.id))
      }
      return this.sortByKey(groups, 'name')
    },
    totalPromoExcludedAdGroups() {
      return this.$store.getters.totalPromoExcludedAdGroups
    }
  },
  methods: {
    close() {
      this.$emit('closeAlignmentModal')
    },
    async generateExport() {
      this.generating = true
      try {
        const payload = { 
          tpr_start_date: this.tpr_start_date,
          ad_group_ids: this.ad_group_ids 
        }
        const { data } = await Promos.generateTPRAlignmentExport(payload)
        if (data) {
          location.href = data
        }
        this.emitAlert(true, 'success', "Export generated successfully", [], true)
      } catch (err) {
        this.handleError(err)
      } finally {
        this.generating = false
      }
    }
  }
}
</script>